import { Editor } from 'slate';
import { TagContinuationBlocker, TagSplitResult } from './utils/split';
import { unwrapTagMarkers, withoutUndo } from './utils/removal';
import { HistoryEditor } from 'slate-history';

export interface TagSplitHandlers {
  onTagSplit: (result: TagSplitResult) => void;
  continuationBlocker: (tagId: string) => TagContinuationBlocker | null;
}

const handlers = new WeakMap<Editor, TagSplitHandlers>();

export const registerTagSplitHandlers = (editor: Editor, splitHandlers: TagSplitHandlers): (() => void) => {
  handlers.set(editor, splitHandlers);
  return () => {
    if (handlers.get(editor) === splitHandlers) handlers.delete(editor);
  };
};

export const tagSplitHandlers = (editor: Editor): TagSplitHandlers | undefined => handlers.get(editor);

export const afterSectionSave = (editor: HistoryEditor, deadTagIds: string[] | undefined): void => {
  if (deadTagIds?.length) withoutUndo(editor, () => unwrapTagMarkers(editor, deadTagIds));
};
